var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9542 2.41736C10.9069 2.65018 10.8822 2.89114 10.8822 3.13791C10.8822 3.38468 10.9069 3.62565 10.9542 3.85846H2.60407L8.04455 8.65878L11.6818 5.40146C11.9891 5.78153 12.3722 6.09784 12.808 6.32745L8.05168 10.587L2.23554 5.45516V13.9462H13.7644V6.6686C13.9972 6.71586 14.2381 6.74067 14.4849 6.74067C14.7317 6.74067 14.9727 6.71586 15.2055 6.6686V14.6667C15.2055 15.0647 14.8829 15.3873 14.4849 15.3873H1.51499C1.11704 15.3873 0.794434 15.0647 0.794434 14.6667V3.13791C0.794434 2.73997 1.11704 2.41736 1.51499 2.41736H10.9542ZM14.4849 0.976257C15.6788 0.976257 16.6466 1.94407 16.6466 3.13791C16.6466 4.33176 15.6788 5.29957 14.4849 5.29957C13.291 5.29957 12.3233 4.33176 12.3233 3.13791C12.3233 1.94407 13.291 0.976257 14.4849 0.976257Z",
    fill: "#F2FF41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIEmail);
export default __webpack_public_path__ + "static/media/i-email.fcab3d6a0f4a0514a994bf5f3c4205b4.svg";
export { ForwardRef as ReactComponent };